module.exports = __webpack_public_path__ + "static/honeyfiLogo-2f133a9a853e9ac3090e8944059d94a8.png";